import { render, staticRenderFns } from "./mgDetails.vue?vue&type=template&id=e7cf5a3a&scoped=true&"
import script from "./mgDetails.vue?vue&type=script&lang=js&"
export * from "./mgDetails.vue?vue&type=script&lang=js&"
import style0 from "./mgDetails.vue?vue&type=style&index=0&id=e7cf5a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cf5a3a",
  null
  
)

export default component.exports